<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Trocas de Produtos em Requisição
            <Modal
              :tipoSelecao="'single'"
              :dataDisable="true"
              @unidade="getTrocasProdutosRequisicao"
              :loadingValue="loadingValue"
            >
              <template v-slot:conteudo>
                <div class="row q-mt-sm text-brand-5 text-weight-bold">
                  <span style="width: 48%" class="col-2 q-ml-sm q-mt-sm"
                    >Data Inicial</span
                  >
                  <span style="width: 44%" class="col-2 q-ml-sm q-mt-sm"
                    >Data Final</span
                  >
                </div>
                <div class="row col col-3 q-px-sm">
                  <q-input
                    style="width: 49%"
                    class="col input"
                    dense
                    outlined
                    placeholder="DD/MM/AAAA"
                    v-model="datas.from"
                    mask="##/##/####"
                    :rules="[
                      (val) => validarDataEmissao(val) || 'Data Invalida',
                    ]"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date
                            :locale="myLocale"
                            :options="optionsFn"
                            mask="DD/MM/YYYY"
                            v-model="datas"
                            range
                          >
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Fechar"
                                color="primary"
                                flat
                              />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                  <q-input
                    class="col q-ml-sm input"
                    style="width: 49%"
                    dense
                    outlined
                    placeholder="DD/MM/AAAA"
                    v-model="datas.to"
                    mask="##/##/####"
                    :rules="[
                      (val) => validarDataEmissao(val) || 'Data Invalida',
                    ]"
                  />
                </div>
                <div class="row q-px-sm text-brand-5 text-weight-bold">
                  <div class="col">
                    <div class="texto-titulo-input">
                      Produto (Código ou Descrição)
                    </div>
                    <q-input
                      dense
                      outlined
                      v-model="produto"
                      placeholder="Digite o código ou a descrição"
                    />
                  </div>
                </div>
              </template>
            </Modal>
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :exportName="'Trocas_Produtos_Requisicao'"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'trocas-produtos-requisicao'"
      @enviarRespostaEp="getRelatorioSalvo"
      @flexmonsterLoading="loadingStop"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { transformCsvAndSetLink } from "../../../utils/csvHelper.js";
import { validarDataEmissao } from "../../../helpers/dateValidation";

import Modal from "../components/Modal.vue";
import Flexmonster from "../components/Flexmonster.vue";

export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: [{ uniqueName: "Entrega_Unidade_Nome" }],
      reportFilters: "",
      measures: [
        { uniqueName: "Requisicao_Numero", aggregation: "distinctcount" },
        { uniqueName: "Centro_Custo_Codigo" },
        { uniqueName: "Centro_Custo_Nome" },
        { uniqueName: "Solicitante_Nome" },
        { uniqueName: "Solicitante_Sap" },
        { uniqueName: "Item_Codigo_Antigo" },
        { uniqueName: "Item_Nome_Contrato_Antigo" },
        { uniqueName: "Item_Ca_Codigo_Antigo" },
        { uniqueName: "Item_Quantidade_Antigo", format: "numberFormat" },
        { uniqueName: "Item_Preco_Antigo", format: "numberFormat" },
        { uniqueName: "Item_Codigo_Novo" },
        { uniqueName: "Item_Nome_Contrato_Novo" },
        { uniqueName: "Item_Ca_Codigo_Novo" },
        { uniqueName: "Item_Quantidade_Novo", format: "numberFormat" },
        { uniqueName: "Item_Preco_Novo", format: "numberFormat" },
        { uniqueName: "Item_Grupo_Nome" },
        { uniqueName: "Criacao_Data" },
        { uniqueName: "Finalizacao_Data" },
        { uniqueName: "Alteracao_Data" },
        { uniqueName: "Nome_Usuario_Troca" },
        { uniqueName: "Matricula_Usuario_Troca" },
      ],
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      Entrega_Unidade_Nome: { type: "string" },
      Requisicao_Numero: { type: "string" },
      Centro_Custo_Codigo: { type: "string" },
      Centro_Custo_Nome: { type: "string" },
      Solicitante_Nome: { type: "string" },
      Solicitante_Sap: { type: "string" },
      Item_Codigo_Antigo: { type: "string" },
      Item_Nome_Contrato_Antigo: { type: "string" },
      Item_Ca_Codigo_Antigo: { type: "string" },
      Item_Quantidade_Antigo: {
        type: "number",
        format: "numberFormat",
      },
      Item_Preco_Antigo: {
        type: "number",
        format: "numberFormat",
      },
      Item_Codigo_Novo: { type: "string" },
      Item_Nome_Contrato_Novo: { type: "string" },
      Item_Ca_Codigo_Novo: { type: "string" },
      Item_Quantidade_Novo: {
        type: "number",
        format: "numberFormat",
      },
      Item_Preco_Novo: {
        type: "number",
        format: "numberFormat",
      },
      Item_Grupo_Nome: { type: "string" },
      Criacao_Data: { type: "string" },
      Finalizacao_Data: { type: "string" },
      Alteracao_Data: { type: "string" },
      Nome_Usuario_Troca: { type: "string" },
      Matricula_Usuario_Troca: { type: "string" },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const produto = ref("");
    const datas = ref({ from: "", to: "" });

    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };

    const optionsFn = (date) => {
      const hoje = new Date();
      const dd = String(hoje.getDate()).padStart(2, "0");
      const mm = String(hoje.getMonth() + 1).padStart(2, "0");
      const yyyy = hoje.getFullYear();
      return date <= `${yyyy}/${mm}/${dd}`;
    };

    const formatarData = (data) => {
      if (!data || data.trim() === "") return "";
      if (data.includes("/")) return data.split("/").reverse().join("-");
      return data;
    };
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
      {
        name: "numberFormat",
        thousandsSeparator: ".",
        decimalSeparator: ",",
        decimalPlaces: -1,
      },
    ]);
    const targetColumns = [];
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const relatorioLink = localStorage.getItem("relatorioLink");

    const getResponseLink = (response) => {
      return (
        response?.data?.return?.url ||
        response?.data?.result?.url ||
        response?.data?.resultado?.dados ||
        response?.return?.url ||
        response?.result?.url ||
        response?.resultado?.dados ||
        ""
      );
    };

    const getTrocasProdutosRequisicao = async (data, singleValue) => {
      try {
        let dataInicial = formatarData(datas.value.from);
        let dataFinal = formatarData(datas.value.to);

        if (!dataInicial) {
          const d = new Date();
          d.setDate(d.getDate() - 15);
          dataInicial = d.toISOString().split("T")[0];
        }
        if (!dataFinal) {
          dataFinal = new Date().toISOString().split("T")[0];
        }

        const filtrosBody = {
          data_inicial: dataInicial,
          data_final: dataFinal,
          unidade_ids: singleValue?.id ? [singleValue.id] : [],
          produto: produto.value || undefined,
        };

        const filtrosObject = {
          unidade: singleValue?.label,
          data_inicial: filtrosBody.data_inicial,
          data_final: filtrosBody.data_final,
          produto: filtrosBody.produto || "",
        };

        loadingValue.value = true;
        const response = await store.dispatch(
          "rel/getTrocasProdutosRequisicao",
          {
            filtros: filtrosBody,
          }
        );

        const responseLink = getResponseLink(response);
        link.value = await transformCsvAndSetLink(responseLink, targetColumns);
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
        loadingValue.value = false;
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        if (store.state.rel.aguardandoFiltros) {
          store.commit("rel/SET_AGUARDANDO_FILTROS", false);
          return;
        }

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = await transformCsvAndSetLink(
          getResponseLink(response),
          targetColumns
        );
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;

      link.value = await transformCsvAndSetLink(
        getResponseLink(response),
        targetColumns
      );

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getTrocasProdutosRequisicao,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtros,
      showTotals,
      getRelatorioSalvo,
      formats,
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
      produto,
      datas,
      myLocale,
      optionsFn,
      validarDataEmissao,
    };
  },
};
</script>
